<template>
	<v-tooltip max-width="800" top color="black" :disabled="isNovoValorVazio">
		<template #activator="{ on }">
			<div v-on="on">
				<az-money
					:id="`item-aditivo-apostila${itemAditivoApostila.id}-novo-valor`"
					v-model="itemAditivoApostila.novoValor"
					placeholder="Informe"
					:negative="false"
					:precision="numeroCasasDecimaisValores"
					prefix="R$ "
					show-clear-button
					:disabled="disabled"
					@input="eventoAlteracao"
				></az-money>
			</div>
		</template>
		<span>{{ itemAditivoApostila.novoValor | rpCurrencyFilter('R$ ', numeroCasasDecimaisValores) }}</span>
	</v-tooltip>
</template>
<script>
import {actionTypes} from "@/core/constants";

export default {
	name: 'alterar-valor-item-aditivo-apostila',
	props: {
		itemSelecionado: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: null,
		},
	},
	data() {
		return {
			itemAditivoApostila: this.itemSelecionado,
			alterarValorTimeout: null,
		}
	},
	computed: {
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisValores
			},
		},
		isNovoValorVazio: {
			get() {
				return !this.itemAditivoApostila.novoValor
			},
		},
	},
	methods: {
		async eventoAlteracao() {
			clearTimeout(this.alterarValorTimeout)
			const evento = async function () {
				await this.alterarValor()
			}.bind(this)
			this.alterarValorTimeout = setTimeout(evento, 1500)
		},
		async alterarValor() {
			const objParams = {
				idItemAditivoApostila: this.itemAditivoApostila.id,
				valor: this.itemAditivoApostila.novoValor,
			}

			await this.$store.dispatch(actionTypes.ITEM_ADITIVO_APOSTILA.ALTERAR_VALOR_ITEM_ADITIVO_APOSTILA, objParams)
		},
	},
}
</script>
